
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'customer-portal-app',
  currentProjectVersion: 'static-1.1585',
  depVersions: {
  "customer-portal-app": "static-1.1585",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.443",
  "data-fetching-client": "static-1.9419",
  "emoji-mart": "static-3.4",
  "enviro": "static-4.387",
  "growth-payments-core": "static-1.24564",
  "head-dlb": "static-1.4754",
  "hs-lodash": "static-4.45",
  "hs-promise-utils": "static-1.5333",
  "hs-test-utils": "static-1.7742",
  "hub-http": "static-1.5872",
  "hub-http-shared-msw-handlers": "static-1.9334",
  "hubspot-dlb": "static-2.1786",
  "hubspot-prosemirror": "static-1.17447",
  "hubspot-url-utils": "static-1.3873",
  "HubStyleTokens": "static-2.11164",
  "I18n": "static-7.1554",
  "immutable": "static-2.19",
  "jasmine-runner": "static-1.6212",
  "payment-link-components": "static-1.22776",
  "prosemirror": "static-1.13",
  "quartz": "static-1.6649",
  "quartz-core": "static-1.5868",
  "react": "static-7.176",
  "react-colorpicker": "static-2.9954",
  "react-dlb": "static-1.70",
  "react-utils": "static-2.5123",
  "rich-text-lib": "static-1.19376",
  "transmute": "static-2.85",
  "ui-addon-upgrades": "static-9.17528",
  "ui-components-test-utils": "static-1.5302",
  "UIComponents": "static-3.8111",
  "foundations-assets": "static-1.4574",
  "foundations-components": "static-1.7408",
  "foundations-theming": "static-1.4150",
  "foundations-theming-specialty": "static-1.1866",
  "framer-motion": "static-1.66",
  "history": "static-4.47",
  "metrics-js": "static-1.9346",
  "PortalIdParser": "static-2.349",
  "portals-platform-lib": "static-1.473",
  "quartz-config": "static-1.427",
  "quartz-routing": "static-1.79",
  "quick-fetch": "static-1.3678",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16381",
  "react-router-dom": "static-5.26",
  "sanitize-text": "static-1.7882",
  "styled-components": "static-2.84",
  "tanstack-table": "static-1.49",
  "ui-addon-draggable": "static-3.4502",
  "ui-addon-react-router-dom": "static-1.9289",
  "usage-tracker": "static-1.7076",
  "usage-tracker-anonymous": "static-1.5493",
  "usage-tracker-core": "static-1.6926",
  "apollo-stack-hubspot": "static-3.79",
  "hs-promise-rejection-tracking": "static-1.5291",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3176",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.2926",
  "quartz-webpack": "static-1.2873",
  "fast-json-stable-stringify": "static-1.4",
  "graphql": "static-1.76",
  "customer-data-objects": "static-1.7378",
  "frontend-preferences-client": "static-1.7669",
  "laboratory-lib": "static-3.6901",
  "onboarding-scopes": "static-1.6202",
  "rpc-client-utils": "static-1.4369",
  "ui-addon-opt": "static-4.8130",
  "HeadJS": "static-2.700",
  "hs-test-utils-bend-plugin": "static-1.2853",
  "msw": "static-1.39",
  "testing-library": "static-1.146",
  "ts-schema": "static-1.3853",
  "webpack-env": "static-1.54",
  "content-assistance-lib": "static-1.7367",
  "cssUtils": "static-1.714",
  "customer-data-ui-utilities": "static-1.9567",
  "HubStyle": "static-2.11472",
  "knowledge-content-types": "static-1.8308",
  "PatternValidationJS": "static-1.437",
  "quartz-i18n": "static-1.324",
  "react-input-autosize": "static-2.17",
  "StyleGuideUI": "static-3.482",
  "ui-addon-emoji-picker": "static-1.9632",
  "ui-addon-i18n": "static-1.10873",
  "ui-business-units-lib": "static-1.8764",
  "ui-shepherd-react": "static-3.9886",
  "video-components-external": "static-1.10398",
  "i18n-data": "static-1.215",
  "moment-timezone": "static-5.77",
  "jasmine": "static-4.4073",
  "commerce-tours-lib": "static-1.5628",
  "customer-data-properties": "static-1.50598",
  "getting-started-shared-tasks": "static-1.17724",
  "growth-onboarding-reliability": "static-1.4831",
  "onboarding-tours": "static-1.16184",
  "reference-resolvers-lite": "static-1.7833",
  "sales-checkout-service-client": "static-1.3430",
  "ui-addon-iframeable": "static-1.8777",
  "user-context": "static-1.4837",
  "dispatcher": "static-1.130",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.782",
  "hubspotter-http": "static-1.4427",
  "icons": "static-2.618",
  "mobile-manifest-mixins": "static-1.473",
  "quartz-auth": "static-1.324",
  "quartz-head": "static-1.314",
  "quartz-test": "static-1.324",
  "usage-tracker-container": "static-1.7066",
  "ui-fonts": "static-1.426",
  "csstype": "static-1.50",
  "hs-story-utils": "static-1.9170",
  "data-token-picker": "static-1.15957",
  "FileManagerLib": "static-1.38365",
  "property-translator": "static-1.5156",
  "atom": "static-1.4813",
  "merchandise-lib": "static-1.256",
  "purchase-motions-components": "static-1.5384",
  "salesImages": "static-1.519",
  "self-service-api": "static-1.9986",
  "SharedI18nStrings": "static-1.179",
  "upgrade-management-service-types": "static-1.4250",
  "foundations-components-test-utils": "static-1.4891",
  "react-select-plus": "static-1.65",
  "react-virtualized": "static-2.93",
  "ui-images": "static-2.1075",
  "bend-plugin-foundations-components": "static-1.3677",
  "floating-ui": "static-1.50",
  "react-aria": "static-1.60",
  "trellis-assets": "static-1.1052",
  "bend-plugin-foundations-theming": "static-1.2633",
  "foundations-theming-base": "static-1.3135",
  "stylex": "static-1.26",
  "js-cookie": "static-1.18",
  "autolinker": "static-3.11",
  "sanitize": "static-1.4217",
  "react-flip-move": "static-1.64",
  "bender-build-tools": "static-1.2867",
  "inbound-db-properties-service-client": "static-1.3627",
  "superstore": "static-1.4514",
  "feedback-loader": "static-1.28751",
  "ai-components-ui-library": "static-1.8198",
  "ui-addon-video-player": "static-1.8437",
  "ui-coaching-tips": "static-1.27792",
  "sassPrefix": "static-1.150",
  "react-dnd-compat": "static-1.4366",
  "react-immutable-proptypes": "static-2.8",
  "react-immutable-render-mixin": "static-1.9",
  "avatar-components": "static-1.2222",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.7902",
  "reselect": "static-2.16",
  "apollo-link-hub-http": "static-2.4391",
  "content-media-composition-data-lib": "static-1.11254",
  "content-media-compositions": "static-2.15261",
  "idb-keyval": "static-1.38",
  "immer": "static-1.33",
  "immerable": "static-1.3897",
  "magpie-lib": "static-1.5331",
  "magpie-types": "static-1.4791",
  "media-bridge-lib": "static-1.18479",
  "video-data-lib": "static-1.34056",
  "commerce-products-lib": "static-1.8680",
  "crm-message-bus": "static-1.42182",
  "growth-data-modal": "static-1.5090",
  "hubspot-apollo-client": "static-1.4622",
  "onboarding-tours-client": "static-1.4398",
  "calling-global-api": "static-1.63490",
  "calling-internal-common": "static-1.31034",
  "calling-lifecycle-internal": "static-1.64872",
  "calling-lifecycle-messages": "static-1.57166",
  "conditional-properties-service-client": "static-1.3572",
  "crm-links": "static-1.5994",
  "customer-data-objects-ui-components": "static-1.12745",
  "customer-data-property-utils": "static-1.7814",
  "external-options-client-types": "static-1.3932",
  "file-manager-components": "static-1.22725",
  "framework-data-schema-resolvers": "static-1.6611",
  "google-libphonenumber": "static-1.32",
  "hs-entities": "static-1.411",
  "inbound-db-meta-service-client": "static-1.3397",
  "inbounddb-objects-service-types": "static-1.3999",
  "meetings-icalendar-utils-lib": "static-1.376",
  "multi-currency-client-types": "static-1.3467",
  "object-builder-ui-client": "static-1.47791",
  "pipeline-validation-client-types": "static-1.3736",
  "property-value-citations": "static-1.1212",
  "pulse": "static-1.242",
  "smart-property-lib": "static-1.5687",
  "tiered-pricing": "static-1.737",
  "ui-addon-form-validation": "static-1.10737",
  "growth-onboarding-confetti": "static-1.2808",
  "growth-onboarding-next-action-utils": "static-1.1237",
  "navigation-components": "static-1.17095",
  "onboarding-tours-utils": "static-1.250",
  "ui-shepherd-tracker": "static-1.7267",
  "ui-universal-auth": "static-1.8618",
  "batch-promise": "static-1.1287",
  "navigation-messaging": "static-1.6422",
  "getting-started-shared-tasks-store": "static-1.16842",
  "hubspotter-http-shared-msw-handlers": "static-1.9332",
  "audio-components": "static-1.5531",
  "FileManagerCore": "static-1.38224",
  "FileManagerImages": "static-1.35876",
  "video-components": "static-1.12401",
  "growth-monetization-service-types": "static-1.4266",
  "nav-client-types": "static-1.2092",
  "purchase-motions-api": "static-1.5387",
  "signup-constants": "static-1.18275",
  "signup-ui-url-generator": "static-2.7797",
  "trials-service-types": "static-1.3667",
  "chatspot-core": "static-1.20102",
  "chirp-fetch": "static-1.1624",
  "ContentUtils": "static-1.67459",
  "copilot-toolkit": "static-1.10384",
  "growth-onboarding-feedback-components": "static-1.6328",
  "hls.js": "static-1.33",
  "reactive-lib": "static-1.468",
  "simple-logging-lib": "static-1.2793",
  "customer-data-tracking": "static-1.6619",
  "products-iframe-lib": "static-1.7172",
  "products-ui-components-shared-msw-handlers": "static-1.9716",
  "hubspot-apollo-cache": "static-1.81",
  "calling-error-reporting": "static-1.31040",
  "shared-worker-versioning": "static-1.10775",
  "calling-usage-tracker": "static-1.6281",
  "voice-sms-access-library": "static-1.73",
  "conversations-skeleton-state": "static-1.6991",
  "location-customization-utils-lib": "static-1.8383",
  "crm-pipelines-api-client-types": "static-1.3913",
  "framework-builder-read-service-client": "static-1.3796",
  "framework-data-schema-quick-fetch": "static-1.6516",
  "persist-promise": "static-1.3444",
  "directed-graph": "static-1.678",
  "event-emitter": "static-1.685",
  "breeze-intelligence-kit": "static-1.5237",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9417",
  "fsm": "static-1.3474",
  "policy-lib": "static-1.6538",
  "react-tinymce": "static-1.54469",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9480",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53595",
  "tinymce-plugins": "static-1.56709",
  "tinymce-themes": "static-1.55565",
  "cropperjs": "static-1.10",
  "redux-toolkit": "static-1.7",
  "urlinator": "static-1.4275",
  "video-embed": "static-1.34890",
  "content-icons-ui": "static-1.2134",
  "social-insights-client-types": "static-1.21192",
  "eligibility-engine-service-types": "static-1.2948",
  "chatspot-client-types": "static-1.10406",
  "markdown-it": "static-1.6",
  "cms-field-types": "static-1.4549",
  "integrations-lib": "static-1.15241",
  "underscore": "static-1.8",
  "sales-views-client-types": "static-1.4036",
  "calling-orchestration-schema": "static-1.34850",
  "crm-record-cards-service-types": "static-1.3400",
  "highcharts": "static-8.98",
  "trellis-story-utils": "static-1.4264",
  "storybook-react": "static-1.27",
  "hub-http-contrib": "static-1.2787",
  "interframe": "static-3.4534",
  "tinymce-data": "static-1.39680",
  "ui-addon-sales-email": "static-1.4955",
  "codemirror": "static-5.89",
  "layout-dnd-components": "static-1.11935",
  "layout-dnd-utils": "static-1.10910",
  "react-codemirror": "static-1.10365",
  "ui-brand-identity-lib": "static-1.13598",
  "NamespacedHubStyle": "static-2.8846",
  "outpost": "static-1.3951",
  "flux-actions": "static-1.302",
  "integrations-error-boundary-lib": "static-1.12656",
  "integrations-tracking-lib": "static-1.5326",
  "native-integrations-shared-strings": "static-1.7531",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10115",
  "rxjs": "static-5.10",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.67534",
  "layout-data-lib": "static-1.9235",
  "browser-eslint": "static-2.57",
  "universal-page-editor-lib": "static-1.2741",
  "advanced-menus-core": "static-1.14730",
  "advanced-menus-lib": "static-1.11718",
  "ExportDialog": "static-6.10130",
  "ui-memberships-settings-lib": "static-1.33278",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14729",
  "simple-menus-lib": "static-1.16246"
},
  depPathPrefixes: {
  "customer-portal-app": "/customer-portal-app/static-1.1585",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.443",
  "data-fetching-client": "/data-fetching-client/static-1.9419",
  "emoji-mart": "/emoji-mart/static-3.4",
  "enviro": "/enviro/static-4.387",
  "growth-payments-core": "/growth-payments-core/static-1.24564",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-promise-utils": "/hs-promise-utils/static-1.5333",
  "hs-test-utils": "/hs-test-utils/static-1.7742",
  "hub-http": "/hub-http/static-1.5872",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9334",
  "hubspot-dlb": "/hubspot-dlb/static-2.1786",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17447",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3873",
  "HubStyleTokens": "/HubStyleTokens/static-2.11164",
  "I18n": "/I18n/static-7.1554",
  "immutable": "/immutable/static-2.19",
  "jasmine-runner": "/jasmine-runner/static-1.6212",
  "payment-link-components": "/payment-link-components/static-1.22776",
  "prosemirror": "/prosemirror/static-1.13",
  "quartz": "/quartz/static-1.6649",
  "quartz-core": "/quartz-core/static-1.5868",
  "react": "/react/static-7.176",
  "react-colorpicker": "/react-colorpicker/static-2.9954",
  "react-dlb": "/react-dlb/static-1.70",
  "react-utils": "/react-utils/static-2.5123",
  "rich-text-lib": "/rich-text-lib/static-1.19376",
  "transmute": "/transmute/static-2.85",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17528",
  "ui-components-test-utils": "/ui-components-test-utils/static-1.5302",
  "UIComponents": "/UIComponents/static-3.8111",
  "foundations-assets": "/foundations-assets/static-1.4574",
  "foundations-components": "/foundations-components/static-1.7408",
  "foundations-theming": "/foundations-theming/static-1.4150",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1866",
  "framer-motion": "/framer-motion/static-1.66",
  "history": "/history/static-4.47",
  "metrics-js": "/metrics-js/static-1.9346",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "portals-platform-lib": "/portals-platform-lib/static-1.473",
  "quartz-config": "/quartz-config/static-1.427",
  "quartz-routing": "/quartz-routing/static-1.79",
  "quick-fetch": "/quick-fetch/static-1.3678",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16381",
  "react-router-dom": "/react-router-dom/static-5.26",
  "sanitize-text": "/sanitize-text/static-1.7882",
  "styled-components": "/styled-components/static-2.84",
  "tanstack-table": "/tanstack-table/static-1.49",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4502",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9289",
  "usage-tracker": "/usage-tracker/static-1.7076",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5493",
  "usage-tracker-core": "/usage-tracker-core/static-1.6926",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3176",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.2926",
  "quartz-webpack": "/quartz-webpack/static-1.2873",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "graphql": "/graphql/static-1.76",
  "customer-data-objects": "/customer-data-objects/static-1.7378",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7669",
  "laboratory-lib": "/laboratory-lib/static-3.6901",
  "onboarding-scopes": "/onboarding-scopes/static-1.6202",
  "rpc-client-utils": "/rpc-client-utils/static-1.4369",
  "ui-addon-opt": "/ui-addon-opt/static-4.8130",
  "HeadJS": "/HeadJS/static-2.700",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2853",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.146",
  "ts-schema": "/ts-schema/static-1.3853",
  "webpack-env": "/webpack-env/static-1.54",
  "content-assistance-lib": "/content-assistance-lib/static-1.7367",
  "cssUtils": "/cssUtils/static-1.714",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9567",
  "HubStyle": "/HubStyle/static-2.11472",
  "knowledge-content-types": "/knowledge-content-types/static-1.8308",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "quartz-i18n": "/quartz-i18n/static-1.324",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "StyleGuideUI": "/StyleGuideUI/static-3.482",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9632",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10873",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8764",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9886",
  "video-components-external": "/video-components-external/static-1.10398",
  "i18n-data": "/i18n-data/static-1.215",
  "moment-timezone": "/moment-timezone/static-5.77",
  "jasmine": "/jasmine/static-4.4073",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5628",
  "customer-data-properties": "/customer-data-properties/static-1.50598",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17724",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4831",
  "onboarding-tours": "/onboarding-tours/static-1.16184",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7833",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3430",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8777",
  "user-context": "/user-context/static-1.4837",
  "dispatcher": "/dispatcher/static-1.130",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.782",
  "hubspotter-http": "/hubspotter-http/static-1.4427",
  "icons": "/icons/static-2.618",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.473",
  "quartz-auth": "/quartz-auth/static-1.324",
  "quartz-head": "/quartz-head/static-1.314",
  "quartz-test": "/quartz-test/static-1.324",
  "usage-tracker-container": "/usage-tracker-container/static-1.7066",
  "ui-fonts": "/ui-fonts/static-1.426",
  "csstype": "/csstype/static-1.50",
  "hs-story-utils": "/hs-story-utils/static-1.9170",
  "data-token-picker": "/data-token-picker/static-1.15957",
  "FileManagerLib": "/FileManagerLib/static-1.38365",
  "property-translator": "/property-translator/static-1.5156",
  "atom": "/atom/static-1.4813",
  "merchandise-lib": "/merchandise-lib/static-1.256",
  "purchase-motions-components": "/purchase-motions-components/static-1.5384",
  "salesImages": "/salesImages/static-1.519",
  "self-service-api": "/self-service-api/static-1.9986",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.179",
  "upgrade-management-service-types": "/upgrade-management-service-types/static-1.4250",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4891",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-virtualized": "/react-virtualized/static-2.93",
  "ui-images": "/ui-images/static-2.1075",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3677",
  "floating-ui": "/floating-ui/static-1.50",
  "react-aria": "/react-aria/static-1.60",
  "trellis-assets": "/trellis-assets/static-1.1052",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2633",
  "foundations-theming-base": "/foundations-theming-base/static-1.3135",
  "stylex": "/stylex/static-1.26",
  "js-cookie": "/js-cookie/static-1.18",
  "autolinker": "/autolinker/static-3.11",
  "sanitize": "/sanitize/static-1.4217",
  "react-flip-move": "/react-flip-move/static-1.64",
  "bender-build-tools": "/bender-build-tools/static-1.2867",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3627",
  "superstore": "/superstore/static-1.4514",
  "feedback-loader": "/feedback-loader/static-1.28751",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8198",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8437",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27792",
  "sassPrefix": "/sassPrefix/static-1.150",
  "react-dnd-compat": "/react-dnd-compat/static-1.4366",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "avatar-components": "/avatar-components/static-1.2222",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.7902",
  "reselect": "/reselect/static-2.16",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4391",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11254",
  "content-media-compositions": "/content-media-compositions/static-2.15261",
  "idb-keyval": "/idb-keyval/static-1.38",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3897",
  "magpie-lib": "/magpie-lib/static-1.5331",
  "magpie-types": "/magpie-types/static-1.4791",
  "media-bridge-lib": "/media-bridge-lib/static-1.18479",
  "video-data-lib": "/video-data-lib/static-1.34056",
  "commerce-products-lib": "/commerce-products-lib/static-1.8680",
  "crm-message-bus": "/crm-message-bus/static-1.42182",
  "growth-data-modal": "/growth-data-modal/static-1.5090",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4622",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4398",
  "calling-global-api": "/calling-global-api/static-1.63490",
  "calling-internal-common": "/calling-internal-common/static-1.31034",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.64872",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57166",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3572",
  "crm-links": "/crm-links/static-1.5994",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12745",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7814",
  "external-options-client-types": "/external-options-client-types/static-1.3932",
  "file-manager-components": "/file-manager-components/static-1.22725",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6611",
  "google-libphonenumber": "/google-libphonenumber/static-1.32",
  "hs-entities": "/hs-entities/static-1.411",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3397",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.3999",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.376",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3467",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47791",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3736",
  "property-value-citations": "/property-value-citations/static-1.1212",
  "pulse": "/pulse/static-1.242",
  "smart-property-lib": "/smart-property-lib/static-1.5687",
  "tiered-pricing": "/tiered-pricing/static-1.737",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10737",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2808",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1237",
  "navigation-components": "/navigation-components/static-1.17095",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.250",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7267",
  "ui-universal-auth": "/ui-universal-auth/static-1.8618",
  "batch-promise": "/batch-promise/static-1.1287",
  "navigation-messaging": "/navigation-messaging/static-1.6422",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16842",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9332",
  "audio-components": "/audio-components/static-1.5531",
  "FileManagerCore": "/FileManagerCore/static-1.38224",
  "FileManagerImages": "/FileManagerImages/static-1.35876",
  "video-components": "/video-components/static-1.12401",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4266",
  "nav-client-types": "/nav-client-types/static-1.2092",
  "purchase-motions-api": "/purchase-motions-api/static-1.5387",
  "signup-constants": "/signup-constants/static-1.18275",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7797",
  "trials-service-types": "/trials-service-types/static-1.3667",
  "chatspot-core": "/chatspot-core/static-1.20102",
  "chirp-fetch": "/chirp-fetch/static-1.1624",
  "ContentUtils": "/ContentUtils/static-1.67459",
  "copilot-toolkit": "/copilot-toolkit/static-1.10384",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6328",
  "hls.js": "/hls.js/static-1.33",
  "reactive-lib": "/reactive-lib/static-1.468",
  "simple-logging-lib": "/simple-logging-lib/static-1.2793",
  "customer-data-tracking": "/customer-data-tracking/static-1.6619",
  "products-iframe-lib": "/products-iframe-lib/static-1.7172",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9716",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.81",
  "calling-error-reporting": "/calling-error-reporting/static-1.31040",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10775",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6281",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.73",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.6991",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8383",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3913",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3796",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6516",
  "persist-promise": "/persist-promise/static-1.3444",
  "directed-graph": "/directed-graph/static-1.678",
  "event-emitter": "/event-emitter/static-1.685",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5237",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9417",
  "fsm": "/fsm/static-1.3474",
  "policy-lib": "/policy-lib/static-1.6538",
  "react-tinymce": "/react-tinymce/static-1.54469",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9480",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53595",
  "tinymce-plugins": "/tinymce-plugins/static-1.56709",
  "tinymce-themes": "/tinymce-themes/static-1.55565",
  "cropperjs": "/cropperjs/static-1.10",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "urlinator": "/urlinator/static-1.4275",
  "video-embed": "/video-embed/static-1.34890",
  "content-icons-ui": "/content-icons-ui/static-1.2134",
  "social-insights-client-types": "/social-insights-client-types/static-1.21192",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2948",
  "chatspot-client-types": "/chatspot-client-types/static-1.10406",
  "markdown-it": "/markdown-it/static-1.6",
  "cms-field-types": "/cms-field-types/static-1.4549",
  "integrations-lib": "/integrations-lib/static-1.15241",
  "underscore": "/underscore/static-1.8",
  "sales-views-client-types": "/sales-views-client-types/static-1.4036",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.34850",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3400",
  "highcharts": "/highcharts/static-8.98",
  "trellis-story-utils": "/trellis-story-utils/static-1.4264",
  "storybook-react": "/storybook-react/static-1.27",
  "hub-http-contrib": "/hub-http-contrib/static-1.2787",
  "interframe": "/interframe/static-3.4534",
  "tinymce-data": "/tinymce-data/static-1.39680",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.4955",
  "codemirror": "/codemirror/static-5.89",
  "layout-dnd-components": "/layout-dnd-components/static-1.11935",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10910",
  "react-codemirror": "/react-codemirror/static-1.10365",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13598",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8846",
  "outpost": "/outpost/static-1.3951",
  "flux-actions": "/flux-actions/static-1.302",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12656",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5326",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7531",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10115",
  "rxjs": "/rxjs/static-5.10",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.67534",
  "layout-data-lib": "/layout-data-lib/static-1.9235",
  "browser-eslint": "/browser-eslint/static-2.57",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2741",
  "advanced-menus-core": "/advanced-menus-core/static-1.14730",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11718",
  "ExportDialog": "/ExportDialog/static-6.10130",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33278",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14729",
  "simple-menus-lib": "/simple-menus-lib/static-1.16246"
}
};
